import { GET, GETPARAMS, POST, PUT } from './api';

const table = 'omni';
const solRoutes = 'sol';

export const getProfissionalClasses = async (params) => {
  return await GETPARAMS(`/${table}/profissionalClasses`, params, true);
};

export const getProfissoes = async (params) => {
  return await GETPARAMS(`/${table}/profissoes`, params, true);
};

export const getPropostaOmni = async (
  id,
  distribuidorId,
  idBanking,
  uploadCrivo
) => {
  return await GET(
    `/${table}/propostas/${distribuidorId}/${id}/${idBanking}/${uploadCrivo}`,
    true
  );
};

export const confirmDocumentation = async (params) => {
  return POST(`/${table}/confirmDocumentation`, params, true);
};

export const sendDocumentation = async (id, params) => {
  return POST(`/${table}/sendDocumentation/${id}`, params, true);
};

export const getSignature = async (params) => {
  return POST(`/${solRoutes}/startSignature`, params, true);
};

export const reprovarOmni = async (id, params) => {
  return await PUT(`/${table}/reprovar/${id}`, params, true);
};

export const reenviaOmni = async (proposalId) => {
  return GET(`/${table}/reenviapropostaomni/${proposalId}`, null, true);
};

export const enviaformalizar = async (params) => {
  return POST(`/${table}/enviaformalizar`, params, true);
};

export const consultaContrato = async (proposalId) => {
  return GET(`/${table}/consultacontrato/${proposalId}`, true);
};
